import AsControl from '../AsControl';
import { withTranslation } from '../Translator';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import { TiledSelectionHorizontal as BaseTiledSelectionHorizontal } from './TiledSelectionHorizontal';

const TranslatedTiledSelectionHorizontal = withTranslation('components')(BaseTiledSelectionHorizontal);
const TiledSelectionHorizontal = AsControl()(TranslatedTiledSelectionHorizontal);
const TiledSelectionHorizontalControl = bindControlToForm()(TiledSelectionHorizontal);

export {
  TiledSelectionHorizontal,
  TiledSelectionHorizontalControl,
};
